import { useMemo } from "react";

import { TContractDetail } from "builder/contract/buildSendContract";
import FormField from "components/application/FormField";
import { PAYMENT_METHODS } from "constants/customer";
import { dateTimeFormat } from "constants/datetime";
import { useLayoutData } from "contexts/LayoutContext";
import { formatDate } from "utils/formatDatetime";

const CertificateAndPaymentInfo = () => {
  const { contractDetail } = useLayoutData<{
    contractDetail?: TContractDetail | null;
  }>();

  const certificateIssuance = useMemo(() => {
    if (!contractDetail) return "";

    return contractDetail?.needParkingCertificate ? "希望する" : "希望しない";
  }, [contractDetail]);

  const formattedDate = useMemo(() => {
    if (!contractDetail?.needParkingCertificate) return;

    return formatDate(contractDetail?.desiredDeliveryDate, dateTimeFormat.DATE_JP);
  }, [contractDetail?.desiredDeliveryDate, contractDetail?.needParkingCertificate]);

  const formattedAddress = useMemo(() => {
    if (!contractDetail?.needParkingCertificate) return;

    return contractDetail?.certificateDeliveryAddressFull ?? "";
  }, [contractDetail?.needParkingCertificate, contractDetail?.certificateDeliveryAddressFull]);

  const { paymentMethodName, cardNumber, lastModified } = useMemo(() => {
    if (contractDetail?.contractPaymentInfo?.paymentMethodType === PAYMENT_METHODS.CREDIT_CARD.type) {
      return {
        paymentMethodName: PAYMENT_METHODS.CREDIT_CARD.label,
        cardNumber: `************${contractDetail?.contractPaymentInfo?.creditCardPaymentMethod.cardLast4}`,
        lastModified: formatDate(
          contractDetail?.contractPaymentInfo?.creditCardPaymentMethod?.updatedAt,
          dateTimeFormat.DATETIME_JP
        ),
      };
    }

    if (contractDetail?.contractPaymentInfo?.paymentMethodType === PAYMENT_METHODS.BANK_TRANSFER.type) {
      return {
        paymentMethodName: PAYMENT_METHODS.BANK_TRANSFER.label,
      };
    }

    return {};
  }, [contractDetail]);

  return (
    <div className="flex flex-col">
      <p className="mb-4 text-[19.2px] font-bold">保管場所使用承諾証明書</p>
      <div>
        <FormField name="証明書の発行" headerClassName="min-w-[140px]" value={certificateIssuance} />
        {formattedDate && <FormField name="受け取り希望日" headerClassName="min-w-[140px]" value={formattedDate} />}
        {formattedAddress && (
          <FormField
            name="受け取り先"
            headerClassName="min-w-[140px]"
            valueClassName="whitespace-pre-line"
            nameWrapperClassName="self-start"
            value={formattedAddress}
          />
        )}
      </div>
      <p className="mb-4 mt-8 text-[19.2px] font-bold">お支払い情報</p>
      <div>
        <FormField
          name="お支払い方法"
          headerClassName="min-w-[140px]"
          wrapperClassName="last:border-0"
          value={paymentMethodName ?? ""}
        />
        {cardNumber && (
          <FormField
            name="カード番号"
            headerClassName="min-w-[140px]"
            wrapperClassName="last:border-0"
            value={cardNumber}
          />
        )}
        {lastModified && (
          <FormField
            name="最終変更日時"
            headerClassName="min-w-[140px]"
            wrapperClassName="last:border-0"
            value={lastModified}
          />
        )}
      </div>
    </div>
  );
};

export default CertificateAndPaymentInfo;
